import { getProductHyperlink } from '@changegps/horizon-component-library';

type GetProductHyperlinkParam = Parameters<typeof getProductHyperlink>[0];

type Param = Omit<GetProductHyperlinkParam, 'environment'> &
  Partial<Pick<GetProductHyperlinkParam, 'environment'>>;

export const getSidebarHyperlink = (param: Param) =>
  getProductHyperlink({ ...param, environment: ENV.ENVIRONMENT });
